'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.color = exports.propTypes = exports.contextTypes = undefined;

var _react = require('react');

var contextTypes = exports.contextTypes = {
  betterReactSpinkit: _react.PropTypes.shape({
    color: _react.PropTypes.string,
    size: _react.PropTypes.number
  })
};

var propTypes = exports.propTypes = {
  color: _react.PropTypes.string,
  size: _react.PropTypes.number
};

var color = exports.color = '#333';


//////////////////
// WEBPACK FOOTER
// ./~/better-react-spinkit/dist/util/defaults.js
// module id = 416
// module chunks = 0